module.exports = __webpack_public_path__ + "static/media/D_K.a611aa95.png";